import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FaRegCalendarAlt } from "react-icons/fa";
import moment from "moment"; // Import moment at top
const CheckAvailbility = () => {
  const [data, setData] = useState();
  const [rooms, setRooms] = useState([{ adult: 1, child: 0 }]);
  const [checkIn, setCheckIn] = useState();
  const [checkOut, setCheckOut] = useState();
  const [totalDays, setTotalDays] = useState(null);
  const [total, setTotal] = useState();
  const [totalAdults, setTotalAdults] = useState(1);
  const [totalChildren, setTotalChildren] = useState(0);

 let navigate = useNavigate()

  let { _id } = useParams();

  const addRoom = () => {
    setRooms([...rooms, { adult: 1, child: 0 }]);
  };

  const deleteRoom = (index) => {
    if (rooms.length > 1) {
      const newRooms = [...rooms];
      newRooms.splice(index, 1);
      setRooms(newRooms);
    } else {
      alert("At least one room is required.");
    }
  };
const updateGuest = (index, type, increment) => {
  const newRooms = [...rooms];
  const value = newRooms[index][type];

  if (type === "adult") {
    if (value + increment > 2) {
      alert("Maximum 2 adults allowed per room.");
      return;
    }
    if (value + increment >= 1) {
      newRooms[index][type] += increment;
    }
  } 
  else if (type === "child") {
    if (value + increment > 2) {
      alert("Maximum 2 children allowed per room.");
      return;
    }
    if (value + increment >= 0) {
      newRooms[index][type] += increment;
    }
  }

  setRooms(newRooms);
};


  async function getApiData() {
    let response = await fetch("http://34.228.14.188:8000/api/roomcart", {
      method: "GET",
      headers: {
        "content-type": "application/json",
      }
    });
    response = await response.json();

    if (response.result === "Done") {
      let item = response.data.find((x) => x._id === _id);
      setData(item);
    } else {
      setData([]);
    }
  }

  const calculateSummary = () => {
    // calculate adults and children
    const adults = rooms.reduce((acc, room) => acc + room.adult, 0);
    const children = rooms.reduce((acc, room) => acc + room.child, 0);

    setTotalAdults(adults);
    setTotalChildren(children);

    const start = new Date(checkIn);
    const end = new Date(checkOut);

    if (!checkIn || !checkOut || end <= start) {
      setTotalDays("Invalid dates");
      setTotal(0);
      return;
    }

    const diffInMs = end - start;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (data && data?.finalPrice) {
      const numberOfRooms = rooms.length;
      const totalPrice = diffInDays * data.finalPrice * numberOfRooms;
      setTotalDays(diffInDays);
      setTotal(totalPrice);
    }
  };


// const handleCheckAvailability = (e) => {
//   if (data?.stockQuantity > 0) {
//     calculateSummary();
//   } else {
//     e.preventDefault();  // prevent Link navigation
//     alert("Room not available");
//   }
// };



const handleCheckAvailability = () => {
  if (!checkIn || !checkOut) {
    alert("Please select both Check-In and Check-Out dates.");
    return;
  }

  const start = new Date(checkIn);
  const end = new Date(checkOut);

  if (end <= start) {
    alert("Check-Out date must be after Check-In date.");
    return;
  }

  if (!data?.stockQuantity || data.stockQuantity <= 0) {
    alert("Room not available");
    return;
  }

  // Agar sab valid hai toh calculate karo & navigate karo
  calculateSummary();

  navigate(`/booking/${_id}`, {
    state: {
      checkIn: moment(checkIn).format('DD-MM-YYYY'),
      checkOut: moment(checkOut).format('DD-MM-YYYY'),
      rooms,
      total,
      totalDays,
      quantity: rooms.length
    }
  });
};

// const handleCheckAvailability = (e) => {
//   if (!checkIn || !checkOut) {
//     alert("Please select both check-in and check-out dates.");
//     return;
//   }

//   const start = new Date(checkIn);
//   const end = new Date(checkOut);

//   if (end <= start) {
//     alert("Check-out date must be after check-in date.");
//     return;
//   }

//   if (data?.stockQuantity > 0) {
//     calculateSummary();

//     // Proceed to booking page if all validations pass
//     navigate(`/booking/${_id}`, {
//       state: {
//         checkIn: moment(checkIn).format('DD-MM-YYYY'),
//         checkOut: moment(checkOut).format('DD-MM-YYYY'),
//         rooms,
//         total,
//         totalDays,
//         quantity: rooms.length
//       }
//     });
//   } else {
//     alert("Room not available");
//   }
// };




  useEffect(() => {
    calculateSummary();
  }, [checkIn, checkOut, rooms, data]);  // run on any change

  useEffect(() => {
    getApiData();
  }, []);

  return (
    <>
    <div className="check-availbilty-hero">
        <img src="/images/payment/checkAvi.png" alt="Room Check Availbilty image for V Hotel The Grand Shoba" />
        {/* <span className='aerostag aerostag-desk'>AERO-STAG</span> */}
    </div>
    <div className="booking-container " s>
      <h2>Reservations</h2>
      <div className="section-box">
        <div className="search-header">1. Search</div>
        <div className="search-content">
          <div className="form-group">
            <label>Check-In</label>
            <FaRegCalendarAlt className='calender-check-mob-in' />
            {/* <input
            className='form-control'
              type="date"
              value={checkIn}
              onChange={(e) => setCheckIn(e.target.value)}
            /> */}
            <input
  type="date"
  min={new Date().toISOString().split('T')[0]} // disables past dates
  value={checkIn}
  onChange={(e) => setCheckIn(e.target.value)}
  className='form-control'
/>

          </div>
          <div className="form-group">
            <FaRegCalendarAlt className='calender-check-mob-out' />
            <label>Check-Out</label>
            <input
              type="date"
              value={checkOut} className='form-control'
              onChange={(e) => setCheckOut(e.target.value)}
            />
          </div>

          {rooms.map((room, index) => (
            <div className="room-box" key={index}>
              <div className="room-header">
                <label>Room {index + 1}</label>
                {rooms.length > 1 && (
                  <button className="delete-btn" onClick={() => deleteRoom(index)}>
                    x
                  </button>
                )}
              </div>
              <div className="guest-controls">
                <div className="counter-group">
                  <span>Adult</span>
                  <div className="counter">
                    <button onClick={() => updateGuest(index, 'adult', -1)}>-</button>
                    <span>{room.adult}</span>
                    <button onClick={() => updateGuest(index, 'adult', 1)}>+</button>
                  </div>
                </div>
                <div className="counter-group">
                  <span>Children (0-12 Years)</span>
                  <div className="counter">
                    <button onClick={() => updateGuest(index, 'child', -1)}>-</button>
                    <span>{room.child}</span>
                    <button onClick={() => updateGuest(index, 'child', 1)}>+</button>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <button className="add-room" onClick={addRoom}>+ ADD ANOTHER ROOM</button>

          {/* <Link
            to={`/booking/${_id}`}
            state={{
               checkIn: moment(checkIn).format('DD-MM-YYYY'),
    checkOut: moment(checkOut).format('DD-MM-YYYY'),
              rooms,
              total,
              totalDays,
              quantity: rooms.length
            }}
          >
            // <button onClick={handleCheckAvailability} className="check-btn">CHECK AVAILABILITY</button>
         

          </Link> */}

          {/* <Link
  to={`/booking/${_id}`}
  state={{
    checkIn: moment(checkIn).format('DD-MM-YYYY'),
    checkOut: moment(checkOut).format('DD-MM-YYYY'),
    rooms,
    total,
    totalDays,
    quantity: rooms.length
  }}
>
  <button onClick={handleCheckAvailability} className="check-btn">CHECK AVAILABILITY</button>
</Link> */}



{/* <button onClick={handleCheckAvailability} className="check-btn">
  CHECK AVAILABILITY
</button> */}



           <button onClick={handleCheckAvailability} className="check-btn w-50">CHECK AVAILABILITY</button>

        </div>

        <div className="info-section">
          <p className="green-text">✓ No card required to confirm booking!</p>
          <ul className="feature-list">
            <li>🏊 Swimming Pool</li>
            <li>🍺 In-house Brewery</li>
            <li>🍸 Lounge and Bar</li>
            <li>🏋️ Gym</li>
            <li>🏛️ Three Versatile Event Spaces</li>
          </ul>
        </div>
      </div>
    </div>
    </>
  );
};

export default CheckAvailbility;
